import { Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

import { OrganizationUsersTable } from '@/components/organizations/table/OrganizationUsersTable';
import { useMyOrganizationQuery } from '@/queries/useMyOrganizationQuery';

function RouteComponent() {
  const { data, isFetching } = useMyOrganizationQuery({
    adminLevels: true,
    users: true,
    stakeholders: true,
  });

  return (
    <>
      <Typography level="h2" gutterBottom>
        Zugeordnete Benutzer*innen
      </Typography>
      <OrganizationUsersTable
        data={data?.users}
        isFetching={isFetching}
        show="users"
        detailsRoutePath="/meine-organisation/benutzerinnen/$userId"
      />
    </>
  );
}

export const Route = createFileRoute('/_authenticated/_management/meine-organisation/benutzerinnen/')({
  component: RouteComponent,
});
